import Vue from "vue";
import { DatePicker, TimeSelect, Calendar, InfiniteScroll } from "element-ui";
import english from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

locale.use(english);

Vue.prototype.$ELEMENT = { zIndex: 5000 };
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(Calendar);
Vue.use(InfiniteScroll);
